<template>
    <router-link class="user-item list-group-item shadow-sm border-0 p-0 mb-1"
                 ref="userItem"
                 active-class="activated"
                 v-bind:class="{ 'my-2': activated, 'shadow-lg': activated, 'approved': user.approved, 'pending': !user.approved, }"
                 v-bind:to="`/users/${ user._id }`">
        <div class="list-group-item list-group-item-action border-0">
            <div class="row no-gutters">
                <div class="col-lg-6 mb-3 mb-lg-0 d-flex flex-row flex-nowrap align-items-center">
                    <div class="mr-2">
                        <b-avatar size="4em"
                                  variant="light"
                                  v-bind:src="avatar">
                            <font-awesome-icon class="h-100 w-100 p-3"
                                               icon="user-tie"
                                               v-if="!avatar && user.role === 'vending-admin'">
                            </font-awesome-icon>
                            <font-awesome-icon class="h-100 w-100 p-3"
                                               icon="user-hard-hat"
                                               v-if="!avatar && user.role === 'vending-site-manager'">
                            </font-awesome-icon>
                        </b-avatar>
                    </div>
                    <div class="flex-grow-1">
                        <h5 class="font-weight-bolder mb-1">
                            {{ user.name }}
                        </h5>
                        <p class="mb-1">
                            {{ user.email }}
                        </p>
                        <p class="mb-0">
                            {{ timeCreated }}加入
                        </p>
                    </div>
                </div>
                <div class="col-lg-6 row no-gutters">
                    <div class="col-6 col-md-4 col-lg d-flex flex-column justify-content-center align-items-center">
                        <h4 class="text-center font-weight-bold mb-0">
                            {{ $config.roleMap[user.role] | capitalize }}
                        </h4>
                        <p class="text-center mb-1">
                            用戶角色
                        </p>
                    </div>

                    <div class="col-6 col-md-4 col-lg d-flex flex-column justify-content-center align-items-center"
                         v-if="user.role === 'vending-vendor'">
                        <!-- <div class="text-center"
                             v-if="isLoadingWhatsAppAccount">
                            <b-spinner label="Loading..."></b-spinner>
                        </div> -->
                        <h4 class="text-center font-weight-bold mb-0">
                            {{ serviceCount }}
                        </h4>
                        <p class="text-center mb-1">
                            服務項目
                        </p>
                    </div>

                    <div class="col-6 col-md-4 col-lg d-flex flex-column justify-content-center align-items-center"
                         v-if="user.role === 'vending-site-manager'">
                        <h4 class="text-center font-weight-bold mb-0">
                            {{siteCount }}
                        </h4>
                        <p class="text-center mb-1">
                            屋苑
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
    import {
        formatDistanceToNow,
        parseISO,
    } from "date-fns";

    import {
        zhTW,
    } from "date-fns/locale";

    import {
        BAvatar,
        VBTooltip,
    } from "bootstrap-vue";

    export default {
        name: "UserItem",
        components: {
            BAvatar,
        },
        directives: {
            "b-tooltip": VBTooltip,
        },
        props: {
            "user": {
                type: Object,
                required: true,
            },
        },
        data () {
            return {
                isLoading: false,
            };
        },
        computed: {
            email () {
                return this.$store.state.admin.user.email;
            },

            activated () {
                return this.user._id === this.$route.params.userId;
            },

            avatar () {
                return this.user.avatar ?
                    `${ this.$config.apiUrl }/${ this.$config.apiVersion }/user/avatar/${ this.user.avatar }` :
                    "";
            },

            services () {
                return this.$store.state.data.services;
            },

            serviceCount () {
                return this.services
                    .filter(
                        ({ owner }) => owner === this.user._id
                    )
                    .length;
            },

            sitesManaged () {
                return this.user?.profile?.sites ?? [];
            },

            siteCount () {
                return this.sitesManaged.length;
            },

            timeCreated () {
                return formatDistanceToNow(
                    parseISO(this.user.createdAt),
                    {
                        "locale": zhTW,
                        "addSuffix": true
                    }
                );
            },
        },
        methods: {
            async getAccountByUserId () {
                if (!this.isLoadingWhatsAppAccount) {
                    this.isLoadingWhatsAppAccount = true;
                    await this.$store.dispatch(
                        "whatsapp/loadAccount",
                        `${ this.user.countryCode }${ this.user.phone }`
                    );
                    this.isLoadingWhatsAppAccount = false;
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .user-item {
        border-radius: 1rem;
        text-decoration: none;

        &.approved {
            border-left: solid 6px #28a745;
        }

        &.pending {
            border-left: solid 6px #ffc107;
        }
    }

    .list-group-item {
        color: rgba(0, 0, 0, 1);

        transition:
            transform 350ms ease-in-out,
            margin 350ms ease-in-out,
            box-shadow 350ms ease-in-out;

        &.activated {
            transform: scale(1.025);
            border-bottom: 1px solid rgba(0, 0, 0, 0.125);
        }
    }

    .btn-status {
        line-height: 1;
    }
</style>
